import React from "react";
import { HashLink as Link } from "react-router-hash-link";

import { Summary } from "affinityUI/data/summary";
import { Range } from "affinityUI/data/valueDisplay";
import { VisuallyHidden } from "affinityUI/elements/visuallyHidden";

import { HospitalConfigurationType } from "../../types";

export const SettingsSummary: React.FC<{ formLink: string; configuration: HospitalConfigurationType }> = ({
  formLink,
  configuration,
}) => {
  return (
    <>
      <Summary.Section
        title="Normal ranges"
        actions={
          <Link to={`${formLink}#normal-ranges`}>
            Edit <VisuallyHidden>Normal ranges</VisuallyHidden>
          </Link>
        }
      >
        <Summary.List>
          <Summary.Item label="WBC">
            <Range value={configuration.wbcRange} /> 10⁹/L
          </Summary.Item>
          <Summary.Item label="Neutrophils">
            <Range value={configuration.neutrophilRange} /> 10⁹/L
          </Summary.Item>
          <Summary.Item label="Haemoglobin Male">
            <Range value={configuration.haemoglobinRangeMale} /> 10⁹/L
          </Summary.Item>
          <Summary.Item label="Haemoglobin Female">
            <Range value={configuration.haemoglobinRangeFemale} /> 10⁹/L
          </Summary.Item>
          <Summary.Item label="Platelets">
            <Range value={configuration.plateletRange} /> 10⁹/L
          </Summary.Item>
        </Summary.List>
      </Summary.Section>
      <Summary.Section
        title="Confirmatory blood test threshold"
        actions={
          <Link to={`${formLink}#confirmatory-test`}>
            Edit <VisuallyHidden>Confirmatory blood test threshold</VisuallyHidden>
          </Link>
        }
      >
        <Summary.List>
          <Summary.Item label="Neutrophils">{configuration.neutrophilThreshold} 10⁹/L</Summary.Item>
        </Summary.List>
      </Summary.Section>
    </>
  );
};
